module.exports = __webpack_public_path__ + "img/loures.a80bf32d.jpg";